import React from 'react';

const Dp = () => {
  return (
    <section className="vision-strategy__dp">
      <div className='new-container'>
        <div className='vision-strategy__dp-content'>
          <div className='vision-strategy__dp-description'>
            <div className='vision-strategy__dp-description-logo-box'>{svgDpLogo}</div>
            <p className='vision-strategy__dp-description-text'>
              To understand the philosophy behind how a wider vision grew from this beginning one needs to know that DFA
              was born from DP World and that DP World was born from the cultural background of Dubai as an entrepot. As
              barriers have progressively risen to world trade in the last ten years, DP World sees the digital
              revolution
              as an alternative engine to create growth.
            </p>
            <p className='vision-strategy__dp-description-text'>
              {' '}
              To deliver this growth however we must provide the opportunity for SME forwarders to digitize, to compete
              with large scale players who are digitizing at scale. SME forwarders who are able to “go global” are the
              key
              to prosperity, we believe.
            </p>
          </div>
          <div className='vision-strategy__dp-image-box'>
            <img
              src='/images/pages/Company/VisionStrategy/3.png'
              alt='DP World Company'
              className='vision-strategy__dp-image'
            />
          </div>
        </div>

      </div>
    </section>
  );
};

const svgDpLogo = (
  <svg xmlns='http://www.w3.org/2000/svg' width='131' height='30' viewBox='0 0 131 30' fill='none'>
    <path
      d='M58.6151 10.5673H53.9395V19.6795H58.6151C59.2242 19.7043 59.832 19.6047 60.402 19.3869C60.972 19.1691 61.4925 18.8375 61.9321 18.412C62.3718 17.9865 62.7216 17.4758 62.9606 16.9107C63.1995 16.3456 63.3227 15.7377 63.3227 15.1234C63.3227 14.5091 63.1995 13.9012 62.9606 13.3361C62.7216 12.771 62.3718 12.2603 61.9321 11.8348C61.4925 11.4093 60.972 11.0777 60.402 10.8599C59.832 10.6421 59.2242 10.5425 58.6151 10.5673ZM58.6019 17.6605H56.0845V12.5995H58.6019C58.9355 12.5934 59.2671 12.6544 59.577 12.7788C59.887 12.9033 60.1692 13.0887 60.4073 13.3243C60.6453 13.5599 60.8344 13.8409 60.9635 14.1509C61.0925 14.4609 61.1591 14.7938 61.1591 15.13C61.1591 15.4662 61.0925 15.799 60.9635 16.1091C60.8344 16.4191 60.6453 16.7001 60.4073 16.9357C60.1692 17.1713 59.887 17.3567 59.577 17.4812C59.2671 17.6056 58.9355 17.6666 58.6019 17.6605Z'
      fill='#000C37'
    />
    <path
      d="M125.478 10.5663H120.803V19.6785H125.478C126.087 19.7033 126.695 19.6038 127.265 19.386C127.835 19.1681 128.356 18.8365 128.795 18.411C129.235 17.9855 129.585 17.4749 129.824 16.9098C130.063 16.3446 130.186 15.7367 130.186 15.1224C130.186 14.5082 130.063 13.9002 129.824 13.3351C129.585 12.77 129.235 12.2593 128.795 11.8338C128.356 11.4083 127.835 11.0767 127.265 10.8589C126.695 10.6411 126.087 10.5416 125.478 10.5663ZM125.465 17.6595H122.948V12.5985H125.465C125.799 12.5924 126.13 12.6534 126.44 12.7778C126.75 12.9023 127.033 13.0877 127.271 13.3233C127.509 13.5589 127.698 13.8399 127.827 14.1499C127.956 14.46 128.022 14.7928 128.022 15.129C128.022 15.4652 127.956 15.7981 127.827 16.1081C127.698 16.4181 127.509 16.6991 127.271 16.9347C127.033 17.1703 126.75 17.3557 126.44 17.4802C126.13 17.6046 125.799 17.6656 125.465 17.6595Z"
      fill="#000C37"
    />
    <path
      d="M64.2524 10.5664H69.5708C70.0245 10.5447 70.4778 10.6166 70.903 10.7777C71.3281 10.9388 71.7161 11.1856 72.0433 11.5031C72.3704 11.8206 72.6298 12.202 72.8056 12.624C72.9813 13.0461 73.0697 13.4998 73.0653 13.9574C73.0691 14.4178 72.9803 14.8741 72.8041 15.2989C72.628 15.7236 72.3681 16.108 72.0403 16.4287C71.7125 16.7494 71.3235 16.9997 70.897 17.1646C70.4704 17.3295 70.0151 17.4055 69.5585 17.388H66.4112V19.6662H64.2393V10.5664H64.2524ZM66.4235 12.5467V15.3813H69.4671C69.6518 15.3813 69.8347 15.3447 70.0054 15.2735C70.176 15.2022 70.3311 15.0978 70.4617 14.9662C70.5923 14.8346 70.6959 14.6784 70.7666 14.5064C70.8373 14.3344 70.8737 14.1501 70.8737 13.964C70.8737 13.7779 70.8373 13.5936 70.7666 13.4216C70.6959 13.2497 70.5923 13.0934 70.4617 12.9618C70.3311 12.8302 70.176 12.7258 70.0054 12.6546C69.8347 12.5834 69.6518 12.5467 69.4671 12.5467H66.4235Z"
      fill="#000C37"
    />
    <path
      d="M88.4685 10.5665L86.5799 16.1453L84.5501 10.5665H81.8006L79.7707 16.1453L77.8822 10.5665H75.6865L78.5381 19.6787H80.6962L83.1753 12.8703L85.6544 19.6787H87.7994L90.651 10.5665H88.4685Z"
      fill="#000C37"
    />
    <path
      d="M101.469 10.5662H107.07C107.996 10.5308 108.899 10.8606 109.587 11.4855C109.911 11.8256 110.156 12.2338 110.304 12.6806C110.453 13.1275 110.501 13.6019 110.446 14.0698C110.391 14.5378 110.233 14.9875 109.985 15.3867C109.736 15.786 109.403 16.1247 109.009 16.3787L110.692 19.6792H108.315L107.044 16.9483H103.64V19.6792H101.482V10.5662H101.469ZM103.614 12.5596V14.9803H106.889C107.06 15.0049 107.234 14.9915 107.399 14.9411C107.564 14.8907 107.716 14.8046 107.845 14.6887C107.973 14.5727 108.075 14.4299 108.143 14.2701C108.211 14.1103 108.243 13.9375 108.238 13.7638C108.238 12.9481 107.724 12.5596 106.889 12.5596H103.614Z"
      fill="#000C37"
    />
    <path d="M111.685 10.5665H113.856V17.5947H119.882V19.6787H111.685V10.5665Z" fill="#000C37" />
    <path
      d="M95.5202 10.4631C92.591 10.4631 90.5742 12.3011 90.5742 15.1234C90.5742 17.9457 92.591 19.7836 95.5202 19.7836C98.4494 19.7836 100.466 17.9457 100.466 15.1234C100.466 12.3011 98.4486 10.4631 95.5202 10.4631ZM95.5202 17.6469C93.8759 17.6469 92.7323 16.6501 92.7323 15.1225C92.7323 13.5949 93.8629 12.5982 95.5202 12.5982C97.1645 12.5982 98.3081 13.5949 98.3081 15.1225C98.3073 15.4785 98.2323 15.8303 98.0881 16.1552C97.9439 16.4802 97.7336 16.771 97.4708 17.0089C97.2081 17.2469 96.8987 17.4266 96.5627 17.5365C96.2267 17.6464 95.8716 17.684 95.5202 17.6469Z"
      fill="#000C37"
    />
    <path
      d="M33.5383 19.8355C29.5026 21.2959 25.1279 21.5184 20.9668 20.4749C17.5566 19.6889 14.4229 18.0644 11.1842 16.9176C6.02901 15.0797 3.43754 16.9312 0.09375 20.7934C1.42857 17.5037 4.2966 13.7474 10.0738 14.2132C13.8808 14.5198 17.3574 15.6387 20.1338 16.0249C33.1811 17.8366 42.5274 10.4171 42.3551 2.65198C43.0166 6.51589 43.3999 15.6268 33.5383 19.8355Z"
      fill="url(#paint0_linear_4769_32836)"
    />
    <path
      d="M20.1353 16.0257C20.0664 13.9256 20.4592 11.8361 21.2856 9.90686C22.112 7.97762 23.3515 6.25638 24.9154 4.86638C26.4793 3.47639 28.3289 2.45203 30.3318 1.86669C32.3346 1.28134 34.4411 1.14949 36.5004 1.48056C34.2291 0.380547 31.7178 -0.120471 29.2019 0.0244531C26.686 0.169377 24.2477 0.955489 22.1156 2.30915C19.9835 3.66281 18.2274 5.53971 17.0117 7.76397C15.796 9.98822 15.1606 12.487 15.1651 15.0263C16.9891 15.4134 18.6551 15.8258 20.1353 16.0257Z"
      fill="url(#paint1_linear_4769_32836)"
    />
    <path
      opacity="0.5"
      d="M20.1334 16.0257C20.0645 13.9256 20.4573 11.8361 21.2837 9.90686C22.11 7.97762 23.3496 6.25638 24.9135 4.86638C26.4774 3.47639 28.327 2.45203 30.3298 1.86669C32.3326 1.28134 34.4391 1.14949 36.4984 1.48056C34.2271 0.380547 31.7159 -0.120471 29.2 0.0244531C26.684 0.169377 24.2458 0.955489 22.1137 2.30915C19.9816 3.66281 18.2254 5.53971 17.0098 7.76397C15.7941 9.98822 15.1587 12.487 15.1631 15.0263C16.9871 15.4134 18.6531 15.8258 20.1334 16.0257Z"
      fill="url(#paint2_linear_4769_32836)"
    />
    <path
      d="M31.159 29.9587C28.3671 30.1677 25.5733 29.5801 23.0975 28.2632C20.6217 26.9464 18.564 24.9535 17.1602 22.5129C26.5745 30.8777 45.1318 24.2848 44.2593 10.5112C44.9185 12.6676 45.0885 14.9457 44.7566 17.1772C44.4247 19.4087 43.5995 21.5365 42.3419 23.4035C41.0842 25.2704 39.4264 26.8288 37.4908 27.9634C35.5551 29.098 33.3913 29.7799 31.159 29.9587Z"
      fill="#000C37"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4769_32836"
        x1="-0.204116"
        y1="21.1035"
        x2="20.7183"
        y2="-7.41979"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E68C" stopOpacity="0.302" />
        <stop offset="0.6" stopColor="#00E68C" />
        <stop offset="0.964" stopColor="#00E68C" stopOpacity="0.361" />
        <stop offset="1" stopColor="#00E68C" stopOpacity="0.302" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4769_32836"
        x1="15.165"
        y1="8.01286"
        x2="36.5004"
        y2="8.01286"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF2261" />
        <stop offset="0.9" stopColor="#FF2261" stopOpacity="0.102" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_4769_32836"
        x1="23.7612"
        y1="17.6603"
        x2="24.588"
        y2="10.4731"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#68022C" />
        <stop offset="0.15" stopColor="#68022C" stopOpacity="0.749" />
        <stop offset="1" stopColor="#68022C" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export default Dp;
